// extracted by mini-css-extract-plugin
export var container = "bC_h";
export var feature = "bC_cP";
export var featureText = "bC_cQ";
export var features = "bC_cM";
export var footer = "bC_cS";
export var footerText = "bC_cT";
export var icon = "bC_bw";
export var section = "bC_j";
export var text = "bC_cl";
export var title = "bC_d";
export var waveOne = "bC_q";
export var waveThree = "bC_cH";
export var waveTwo = "bC_n";
export var waves = "bC_cG";